var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication-authentication-module"
	],
	"./explore/explore.module": [
		"./src/app/explore/explore.module.ts",
		"explore-explore-module"
	],
	"./nobias-recommended/nobias-recommended.module": [
		"./src/app/nobias-recommended/nobias-recommended.module.ts",
		"nobias-recommended-nobias-recommended-module"
	],
	"./static-views/static.module": [
		"./src/app/static-views/static.module.ts",
		"static-views-static-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;